import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  templateConfig: null,
  slides: [],
  selectedSlide: 0,
  selectedLayer: null,
  emojiPanel: false,
  bgPanel: false,
  musicPanel: false,
  isPlaying: false,
};

const globalAppSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setTemplateConfig(state, action) {
      state.templateConfig = action.payload;
    },
    setSlides(state, action) {
      state.slides = action.payload;
    },
    setSelectedSlide(state, action) {
      state.selectedSlide = action.payload;
      state.selectedLayer = null; 
    },
    setSelectedLayer(state, action) {
      state.selectedLayer = action.payload;
    },
    setPlaying(state, action) {
      state.isPlaying = action.payload;
    },
    updateSlideText(state, action) {
       const { slideIndex, textIndex, content } = action.payload;
       if(state.slides[slideIndex]?.texts[textIndex]) {
           state.slides[slideIndex].texts[textIndex].content = content;
       }
    },
    updateSlideImage(state, action) {
        const { slideIndex, imageIndex, data } = action.payload;
        if(state.slides[slideIndex]?.images[imageIndex]) {
            state.slides[slideIndex].images[imageIndex] = { 
                ...state.slides[slideIndex].images[imageIndex], 
                ...data 
            };
        }
     },
     addSlideImage(state, action) {
         const { slideIndex, image } = action.payload;
         if(state.slides[slideIndex]) {
             state.slides[slideIndex].images.push(image);
         }
     },
     // --- NEW: REMOVE LAYER ---
     removeSlideLayer(state, action) {
        const { slideIndex, layerIndex, type } = action.payload;
        if (state.slides[slideIndex]) {
            if (type === 'text') {
                state.slides[slideIndex].texts.splice(layerIndex, 1);
            } else if (type === 'image') {
                state.slides[slideIndex].images.splice(layerIndex, 1);
            }
            state.selectedLayer = null; // Deselect after delete
        }
     },
     // -------------------------
     toggleEmojiPanel(state) {
       state.emojiPanel = !state.emojiPanel;
     },
     toggleBGPanel(state) {
       state.bgPanel = !state.bgPanel;
     },
     toggleMusicPanel(state) {
       state.musicPanel = !state.musicPanel;
     }
  },
});

export const {
  setTemplateConfig,
  setSlides,
  setSelectedSlide,
  setSelectedLayer,
  setPlaying,
  updateSlideText,
  updateSlideImage,
  addSlideImage,
  removeSlideLayer,
  toggleEmojiPanel,
  toggleBGPanel,
  toggleMusicPanel
} = globalAppSlice.actions;

export default globalAppSlice.reducer;